const routes = [
  {
    path: '/live-detail',
    name: 'live-detail',
    component: () => import('@/views/live/LiveDetail.vue'),
    meta: {
      title: '',
    },
  },
];
export default routes;
